<template>
    <div class="container mt-5 mb-0 py-5 text-center d-flex justify-content-center">
        <div class="col-md-8 justify-content-center">
            <img src="../assets/svg/contact.svg" class="w-50 mx-auto" alt="Icon">
            <h2 class="h2-responsive my-4">{{ msg.title }}</h2>
            <p>{{ msg.text }}</p>
            <router-link class="btn btn-pink btn-rounded" to="/contact">{{ msg.button }}</router-link>
        </div>
    </div>
</template>

<script>
    import { lang } from './../language';

    export default {
        name: 'ContactComponent',
        data() {
            return {
                msg: null,
            }
        },
        created() {
            this.msg = lang.app.contact;
        },
    }
</script>